<template>
  <div class="head">
    <div class="headwrap">
      <div class="left">
        <div class="image">
          <!-- index 显示根菜单    product 显示产品   solution 显示解决方案 -->
          <img
            v-if="!isMenuShow "
            @click="goTo('mobile')"
            src="../../assets/images/mobile/home/logo-menu.png"
            alt
          />
          <img
            @click="goTo('mobile')"
            v-if="isMenuShow && type == 'index'"
            src="../../assets/images/mobile/home/logo-menu.png"
            alt
          />
          <i
            v-if="isMenuShow && (type == 'product'|| type =='solution')"
            @click="change('index')"
            class="iconfont  iconyoujiantouleft-copy"
          ></i>
          <!-- <i
            @click="change('index')"
            v-if="type =='solution'"
            class="iconfont  iconyoujiantouleft-copy"
          ></i> -->
        </div>
      </div>
      <div class="right">
        <i
          class="iconfont iconcaidan"
          v-show="!isMenuShow"
          @click="isMenuShow=true"
        ></i>
        <i
          class="iconfont cha iconcha "
          v-show="isMenuShow"
          @click="isMenuShow=false"
        ></i>
      </div>
    </div>
    <!-- 根目录菜单 -->
    <transition name="fade">
      <div
        class="items"
        v-show="isMenuShow==true && type == 'index'"
      >
        <div
          class="item"
          @click="goTo('mobile')"
        >{{$t('m_menu.home')}}
        </div>
        <div
          class="item"
          @click="goTo('skill')"
        >技术
        </div>
        <div
          class="item"
          @click="change('product')"
        >
          <span>产品</span>
          <i class="i iconfont iconyoujiantou-copy"></i>
        </div>

        <div
          class="item"
          @click="change('solution')"
        >
          <span>解决方案</span>
          <i class="i iconfont iconyoujiantou-copy"></i>
        </div>

        <div
          class="item"
          @click="goTo('newslist')"
        >{{$t('m_menu.news')}}
        </div>
        <div
          class="item"
          @click="goTo('aboutus')"
        >{{$t('m_menu.aboutus')}}
        </div>
        <div
          class="item"
          @click="goTo('joinUs')"
        >加入我们

        </div>
        <!-- <div
          class="item cnen"
          v-if="!isEn"
          @click="toEN"
        >
          中
          <span>/EN</span>
        </div>
        <div
          class="item cnen"
          v-if="isEn"
          @click="toCN"
        >
          <span>中/</span>EN
        </div> -->
      </div>
    </transition>
    <!-- 产品子菜单 -->
    <transition name="fade">
      <div
        class="items"
        v-show="isMenuShow==true && type == 'product'"
      >
        <!-- 底层架构 -->
        <div
          class="item "
          @click="infrastructure=!infrastructure"
        >
          <span>底层架构</span>
          <i
            v-show="infrastructure == false"
            class="i iconfont iconyoujiantou-copy-copy"
          ></i>
          <i
            v-show="infrastructure == true"
            class="i iconfont iconyoujiantou-copy-copy-copy"
          ></i>
        </div>
        <div
          class="item1"
          v-show="infrastructure==true"
        >
          <p @click="goProduct('platform')">底层核心平台</p>
          <p @click="goProduct('CoChain')">Co-Chain</p>
        </div>

        <!-- 开发者工具 -->
        <div
          class="item "
          @click="developer=!developer"
        >
          <span>开发者工具</span>
          <i
            v-show="developer == false"
            class="i iconfont iconyoujiantou-copy-copy"
          ></i>
          <i
            v-show="developer == true"
            class="i iconfont iconyoujiantou-copy-copy-copy"
          ></i>
        </div>
        <div
          class="item1"
          v-show="developer==true"
        >
          <p @click="goProduct('developer')">开发者平台</p>
          <p @click="goProduct('DataAPI')">Data-API</p>
        </div>

        <!-- 区块链云服务 -->
        <div
          class="item "
          @click="cloud=!cloud"
        >
          <span>区块链云服务</span>
          <i
            v-show="cloud == false"
            class="i iconfont iconyoujiantou-copy-copy"
          ></i>
          <i
            v-show="cloud == true"
            class="i iconfont iconyoujiantou-copy-copy-copy"
          ></i>
        </div>
        <div
          class="item1"
          v-show="cloud==true"
        >
          <p @click="goProduct('baas')">恒为BaaS平台</p>
        </div>
        <!-- 区块链运维 -->
        <div
          class="item "
          @click="operation=!operation"
        >
          <span>区块链运维</span>
          <i
            v-show="operation == false"
            class="i iconfont iconyoujiantou-copy-copy"
          ></i>
          <i
            v-show="operation == true"
            class="i iconfont iconyoujiantou-copy-copy-copy"
          ></i>
        </div>
        <div
          class="item1"
          v-show="operation==true"
        >
          <p @click="goProduct('browser')">区块链浏览器</p>
          <p @click="goProduct('operation')">区块链运维监控平台</p>
          <p @click="goProduct('gateway')">存证服务前置网关</p>
        </div>
        <!-- 数字资产 -->
        <div
          class="item "
          @click="assets=!assets"
        >
          <span>数字资产</span>
          <i
            v-show="assets == false"
            class="i iconfont iconyoujiantou-copy-copy"
          ></i>
          <i
            v-show="assets == true"
            class="i iconfont iconyoujiantou-copy-copy-copy"
          ></i>
        </div>
        <div
          class="item1"
          v-show="assets==true"
        >
          <p @click="goProduct('digitization')">资产数字化平台</p>
          <p @click="goProduct('toolkit')">数字资产工具包</p>
        </div>
      </div>

    </transition>
    <!-- 解决方案 -->
    <transition name="fade">
      <div
        class="items"
        v-show="isMenuShow==true && type == 'solution'"
      >
        <!-- 金融 -->
        <div
          class="item "
          @click="finance=!finance"
        >
          <span>金融+区块链</span>
          <i
            v-show="finance == false"
            class="i iconfont iconyoujiantou-copy-copy"
          ></i>
          <i
            v-show="finance == true"
            class="i iconfont iconyoujiantou-copy-copy-copy"
          ></i>
        </div>
        <div
          class="item1"
          v-show="finance==true"
        >
          <p @click="goSolution('onlineTrad')">区块链线上交易平台</p>
          <p @click="goSolution('pointsMall')">区块链积分商城</p>
          <p @click="goSolution('asset')">区块链证券交易平台</p>
          <p @click="goSolution('clear')">区块链清结算平台</p>
          <p @click="goSolution('supplyChain')">区块链供应链金融平台</p>
        </div>

        <!-- 医疗 -->
        <div
          class="item "
          @click="medical=!medical"
        >
          <span>医疗+区块链</span>
          <i
            v-show="medical == false"
            class="i iconfont iconyoujiantou-copy-copy"
          ></i>
          <i
            v-show="medical == true"
            class="i iconfont iconyoujiantou-copy-copy-copy"
          ></i>
        </div>
        <div
          class="item1"
          v-show="medical==true"
        >
          <p @click="goSolution('vaccine')">区块链疫苗溯源平台</p>
          <p @click="goSolution('medicalCare')">区块链处方流转平台</p>
          <p @click="goSolution('classification')">区块链分级诊疗平台</p>
        </div>

        <!-- 农业 -->
        <div
          class="item "
          @click="agriculture=!agriculture"
        >
          <span>农业+区块链</span>
          <i
            v-show="agriculture == false"
            class="i iconfont iconyoujiantou-copy-copy"
          ></i>
          <i
            v-show="agriculture == true"
            class="i iconfont iconyoujiantou-copy-copy-copy"
          ></i>
        </div>
        <div
          class="item1"
          v-show="agriculture==true"
        >
          <p @click="goSolution('agriculture')">区块链农渔产品溯源平台</p>
        </div>
        <!-- 政务+区块链 -->
        <div
          class="item "
          @click="affairs=!affairs"
        >
          <span>政务+区块链</span>
          <i
            v-show="affairs == false"
            class="i iconfont iconyoujiantou-copy-copy"
          ></i>
          <i
            v-show="affairs == true"
            class="i iconfont iconyoujiantou-copy-copy-copy"
          ></i>
        </div>
        <div
          class="item1"
          v-show="affairs==true"
        >
          <p @click="goSolution('government')">区块链数据治理监管平台</p>
          <p @click="goSolution('countryside')">区块链农村三资监管平台</p>
        </div>
      </div>

    </transition>

    <transition name="fade">
      <div
        class="meng"
        @click="isMenuShow=false"
        v-show="isMenuShow==true"
      ></div>
    </transition>
  </div>
</template>
<script>
export default {
  inject: ["reload"],
  data() {
    return {
      isMenuShow: false,
      isEn: localStorage.getItem("Lang") == "en" ? true : false,
      window: window,
      type: localStorage.getItem("type")
        ? localStorage.getItem("type")
        : "index", //index 显示根菜单    product 显示产品   solution 显示解决方案
      infrastructure: false, //底层架构
      developer: false, //开发者工具
      cloud: false, //区块链云服务
      operation: false, //区块链运维
      assets: false, //数字资产
      finance: false,
      medical: false, //医疗
      agriculture: false,
      affairs: false,
    };
  },
  methods: {
    toEN() {
      this.isEn = true;
      this.isMenuShow = false;
      this.$i18n.locale = "en";
      localStorage.setItem("Lang", "en");
      this.reload();
    },
    toCN() {
      this.isEn = false;
      this.isMenuShow = false;
      this.$i18n.locale = "cn";
      localStorage.setItem("Lang", "cn");
      this.reload();
    },
    toDevelopers() {
      window.open("https://developers.hwelltech.com");
      isMenuShow = false;
    },

    //菜单切换
    change(type) {
      if (type == "product") {
        this.type = "product";
        localStorage.setItem("type", "product");
      } else if (type == "solution") {
        this.type = "solution";
        localStorage.setItem("type", "solution");
      } else if (type == "index") {
        this.type = "index";
        localStorage.setItem("type", "index");
      }
    },

    //根菜单跳转
    goTo(name) {
      if (name == "mobile") {
        this.$router.push("/mobile");
      } else if (name == "skill") {
        if (this.$route.meta.flag == "mobileHome") {
          this.$emit("type", 2);
        } else {
          this.$router.push("/mobile?#skill");
        }
      } else if (name == "newslist") {
        this.$router.push("/mobile/newslist");
      } else if (name == "aboutus") {
        this.$router.push("/mobile/aboutus");
      } else if (name == "joinUs") {
        this.$router.push("/mobile/joinUs");
      }
      localStorage.setItem("type", "index");
      this.isMenuShow = false;
    },

    //产品跳转
    goProduct(name) {
      if (name == "platform") {
        this.$router.push("/mobile/product/platform");
      } else if (name == "hwl") {
        this.$router.push("/mobile/product/hwl");
      } else if (name == "CoChain") {
        this.$router.push("/mobile/product/CoChain");
      } else if (name == "DataAPI") {
        this.$router.push("/mobile/product/DataAPI");
      } else if (name == "baas") {
        this.$router.push("/mobile/product/baas");
      } else if (name == "operation") {
        this.$router.push("/mobile/product/operation");
      } else if (name == "gateway") {
        this.$router.push("/mobile/product/gateway");
      } else if (name == "digitization") {
        this.$router.push("/mobile/product/digitization");
      } else if (name == "toolkit") {
        this.$router.push("/mobile/product/toolkit");
      } else if (name == "developer") {
        window.open("https://developers.hwelltech.com/");
      } else if (name == "browser") {
        window.open("https://explorer.hwelltech.com/");
      }
      localStorage.setItem("type", "product");
      this.isMenuShow = false;
    },

    //解决方案
    goSolution(name) {
      if (name == "onlineTrad") {
        this.$router.push("/mobile/solution/onlineTrad");
      } else if (name == "pointsMall") {
        this.$router.push("/mobile/solution/pointsMall");
      } else if (name == "asset") {
        this.$router.push("/mobile/solution/asset");
      } else if (name == "clear") {
        this.$router.push("/mobile/solution/clear");
      } else if (name == "supplyChain") {
        this.$router.push("/mobile/solution/supplyChain");
      } else if (name == "vaccine") {
        this.$router.push("/mobile/solution/vaccine");
      } else if (name == "medicalCare") {
        this.$router.push("/mobile/solution/medicalCare");
      } else if (name == "classification") {
        this.$router.push("/mobile/solution/classification");
      } else if (name == "agriculture") {
        this.$router.push("/mobile/solution/agriculture");
      } else if (name == "government") {
        this.$router.push("/mobile/solution/government");
      } else if (name == "countryside") {
        this.$router.push("/mobile/solution/countryside");
      }
      localStorage.setItem("type", "solution");
      this.isMenuShow = false;
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/css/mixin';

.head {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  height: vw(97);
  width: vw(750);
  background: #fff;
}

.headwrap {
  position: absolute;
  background: #fff;
  height: vw(97);
  width: vw(750);
  padding-left: vw(36);
  padding-right: vw(15);
  border-bottom: vw(2) solid rgba(213, 213, 213, 1);
  z-index: 2;

  .left {
    width: 50%;
    height: vw(96);
    line-height: vw(96);
    display: inline-block;
    text-align: left;
    overflow: hidden;

    .image {
      height: vw(34);
      width: vw(132);
      margin-top: vw(25);

      img {
        width: 100%;
        height: auto;
        display: block;
      }

      i {
        color: rgba(128, 128, 128, 1);
        font-weight: 500;
        font-size: vw(43);
        display: block;
        line-height: vw(48);
      }
    }
  }

  .right {
    width: 50%;
    display: inline-block;
    text-align: right;
    vertical-align: top;
    height: vw(96);
    line-height: vw(96);
    padding-right: vw(20);

    i {
      color: #808080;
      font-size: vw(44);

      &.cha {
        color: #808080;
        font-size: vw(40);
      }
    }
  }
}

.items {
  position: absolute;
  left: 0;
  top: vw(96);
  width: vw(750);
  padding: 0 vw(36);
  background-color: #fff;
  z-index: 2;

  .item {
    height: vw(120);
    line-height: vw(120);
    font-size: vw(32);
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    border-bottom: vw(1) solid rgba(213, 213, 213, 1);
    position: relative;

    &:last-child {
      border-bottom: none;
    }

    &:first-child {
      border-top: vw(1) solid rgba(213, 213, 213, 1);
    }

    &.cnen {
      span {
        color: #999999;
      }
    }

    .i {
      position: absolute;
      right: vw(0);
      color: rgba(178, 178, 178, 1);
      font-size: vw(35);
    }
  }

  .item1 {
    line-height: vw(90);
    font-size: vw(31);
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    border-bottom: vw(1) solid rgba(213, 213, 213, 1);
    padding: vw(25) 0 vw(25) vw(30);

    p {
      font-size: vw(28);
      color: rgba(102, 102, 102, 1);
    }
  }

  .isshow {
    height: 100vh;
  }
}

.meng {
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to { /* .fade-leave-active below version 2.1.8 */
  opacity: 0;
}
</style>
